import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a5f3a534&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5f3a534')) {
      api.createRecord('a5f3a534', component.options)
    } else {
      api.reload('a5f3a534', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a5f3a534&", function () {
      api.rerender('a5f3a534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YoILXyPla7QI/JS/comp/ImgFallback.vue"
export default component.exports